import React, { useEffect, useState, useRef } from "react";
import Card from '@mui/material/Card';
import { Paper } from "@material-ui/core";
import "../../styles/devices/mob_UserProfile.css";
import { Button, TextField, Select, MenuItem } from '@mui/material';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import { IconButton } from "@material-ui/core";
import { DataGrid } from "@material-ui/data-grid";
import HelpSnackbar from "../../components/utils/HelpSnackbar";
import { useDataProvider } from "../../api/DataProvider";
import { useCommProvider } from "../../api/CommProvider";
import { useTranslation } from "react-i18next";
import CheckIcon from '@mui/icons-material/Check';
import ClearIcon from '@mui/icons-material/Clear';


export function DialogInvitationSection(props) {

  const { infoTeam, setInfoTeam } = props;
  const { t } = useTranslation("global")
  
  const [rows, setRows] = useState([]);
  const [pageSize, setPageSize] = useState(5);
  const [showBtnInvitation, setShowBtnInvitation] = useState(false);
  const input_user_id_ref = useRef("");
  const [snack, setSnack] = useState({ open: false, text: "" });
  const { token_id, currentUser } = useDataProvider();
  const { comm_getInfoTeam, comm_acceptInvitationMemberTeam, comm_requestInvitationMemberTeam, comm_cancelInvitationMemberTeam} = useCommProvider();


  const NUMBER_CHARACTERS_VALID = 27

  const [columns, setColumns] = useState([
    { field: "id", headerName: t("sTable.identifier"), sortable: false, flex: 1 },
    { field: "name", headerName: t("sTable.name"), sortable: false, flex: 1.5 },
    { field: "accesible", headerName: t("sTable.state"), sortable: false, flex: 1, align: "center", renderCell: (params) => gridTeamAccessStatus(params)},
    { field: "action", headerName: t("sTable.action"), sortable: false, flex: 1, align: "center", renderCell: (params) => gridTeamAccessActions(params)},
  ]);


  function gridTeamAccessStatus(params) {
    // console.log('params: ', params)
    let status = 'None'
    if (params.row.accesible === true) {
      status = t("sTable.cell_register_valid")
    }else if (params.row.request_admin === true) {
      status = t("sTable.cell_pending_user")
    }else if (params.row.request_user === true) {
      status = t("sTable.cell_pending_admin")
    }
    return <span>{status}</span>
  }

  function gridTeamAccessActions(params) {
    if (params.row.admin === true || params.row.accesible === true | params.row.request_admin === true) {
        return <Button style={{backgroundColor: 'red'}} className="sig_SignDialog_Button sig_SignDialog_Button_ReportBug" onClick={() => handleClickCancelInvitation(params.row.id)}> {t("strButton.btn_remove").toUpperCase()} </Button>
    }else if (params.row.request_user === true){
        return <div style={{ display: 'flex', justifyContent: 'space-between', gap: '2px'}}>
            {/* <Button style={{backgroundColor: 'green'}} className="sig_SignDialog_Button sig_SignDialog_Button_ReportBug" onClick={() => handleClickAcceptInvitation(params.row.id)}> {t("strButton.btn_accept").toUpperCase()} </Button>
            <Button style={{backgroundColor: 'red'}} className="sig_SignDialog_Button sig_SignDialog_Button_ReportBug" onClick={() => handleClickCancelInvitation(params.row.id)}> {t("strButton.btn_cancel").toUpperCase()} </Button> */}


            <Button style={{backgroundColor: 'green'}} className="sig_SignDialog_Button sig_SignDialog_Button_ReportBug" onClick={() => handleClickAcceptInvitation(params.row.id)}> <CheckIcon/> </Button>
            <Button style={{backgroundColor: 'red'}} className="sig_SignDialog_Button sig_SignDialog_Button_ReportBug" onClick={() => handleClickCancelInvitation(params.row.id)}> <ClearIcon/> </Button>
        </div>
    }
  }

  useEffect(() => {
    setRows(infoTeam['users_state'])
  }, [infoTeam]);

  
  async function handleClickCancelInvitation(user_id){
    try{
      await comm_cancelInvitationMemberTeam(token_id, currentUser, infoTeam['_id'], user_id)
      setSnack({ ...snack, open: true, text: t("sSnack.invitation_section_cancel_delete_user")+": "+ user_id, type: "info" });
    }catch{
      setSnack({ ...snack, open: true, text: t("sSnack.invitation_section_error_cancel_detete_user")+".", type: "error" });
    }
    setInfoTeam(await comm_getInfoTeam(token_id, currentUser, infoTeam['_id']))
  }

  async function handleClickAcceptInvitation(user_id){
    try{
      await comm_acceptInvitationMemberTeam(token_id, currentUser, infoTeam['_id'], user_id)
      setSnack({ ...snack, open: true, text: t("sSnack.invitation_section_accept_invitation")+": "+ user_id, type: "info" })
    }catch{
      setSnack({ ...snack, open: true, text: t("sSnack.invitation_section_error")+".", type: "error" });
    }
    setInfoTeam(await comm_getInfoTeam(token_id, currentUser, infoTeam['_id']))
  }

  function handleChange(){
    (input_user_id_ref.current.value.length > NUMBER_CHARACTERS_VALID) ? setShowBtnInvitation(true) : setShowBtnInvitation(false)
  }


  async function handleClickRequestInvitation() {
    const target_user_id = input_user_id_ref.current.value
    const team_id = infoTeam['_id']
    try{
      await comm_requestInvitationMemberTeam(token_id, currentUser, team_id, target_user_id)
      setSnack({ ...snack, open: true, text: t("sSnack.invitation_section_request_invitation")+": "+ target_user_id, type: "info" });
    }catch{
      setSnack({ ...snack, open: true, text: t("sSnack.invitation_section_error_request_invitation")+".", type: "error" });
    }
    setInfoTeam(await comm_getInfoTeam(token_id, currentUser, team_id))
    input_user_id_ref.current.value = ""
    setShowBtnInvitation(false)
  }


  return (
    <>
      <Paper className="sig_Teams_PaperContent">
          <Card>
            <div className='sig_Teams_Info_Root'>
              <div className='sig_Teams_MainContainer'>
                <div>
                    <div className="sig_SignModal_PaperTitle">{t("sTeams.invitation_insert_user")+"."}</div>
                </div>
                  <TextField 
                        variant="outlined"
                        fullWidth
                        size="small"
                        inputRef={input_user_id_ref}
                        className="sig_Teams_TexField"
                        onChange={(e) => handleChange()}
                      />
                  {showBtnInvitation ?
                    <IconButton onClick={handleClickRequestInvitation}>  <AddCircleOutlineIcon fontSize="large" className="sig_Teams_AddButton"/> </IconButton>
                    : <></>                 
                  }
                  
              </div>
            </div>
          </Card>
          
      </Paper>
      <div className="sig_BugReport_Root"> 
        <div className="sig_RecordsRegister_ST_Container">
          <DataGrid
            autoHeight
            pageSize={pageSize}
            rowsPerPageOptions={[10, 25, 50, 100]}
            pagination
            disableSelectionOnClick
            disableColumnMenu
            columns={columns}
            rows={rows}
          />
        </div>
      </div>
      <HelpSnackbar snack={snack} setSnack={setSnack} />
    </>
  );
}